import apiClient from "./axios";
import { ApiResponse, AdminUser, AdminRole } from "../types";

export interface CreateAdminDto {
  email: string;
  firstName: string;
  lastName: string;
  roleId: string;
  profilePhotoBase64?: string;
}

export interface UpdateAdminDto {
  roleId?: string;
  status?: "active" | "inactive";
}

export interface CreateAdminResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  profilePhoto: string | null;
  role: AdminRole;
  roleId: string | null;
  roleName: string | null;
  status: string;
  temporaryPassword: string;
}

export interface ResetAdminLoginResponse {
  email: string;
  temporaryPassword: string;
}

export const adminsApi = {
  getAdmins: async () => {
    const { data } =
      await apiClient.get<ApiResponse<AdminUser[]>>("/admin/admins");
    return data.data;
  },

  createAdmin: async (dto: CreateAdminDto) => {
    const { data } = await apiClient.post<ApiResponse<CreateAdminResponse>>(
      "/admin/admins",
      dto,
    );
    return data.data;
  },

  updateAdmin: async (id: string, dto: UpdateAdminDto) => {
    const { data } = await apiClient.patch<ApiResponse<AdminUser>>(
      `/admin/admins/${id}`,
      dto,
    );
    return data.data;
  },

  deactivateAdmin: async (id: string) => {
    const { data } = await apiClient.delete<ApiResponse<{ message: string }>>(
      `/admin/admins/${id}`,
    );
    return data.data;
  },

  reactivateAdmin: async (id: string) => {
    const { data } = await apiClient.patch<ApiResponse<{ message: string }>>(
      `/admin/admins/${id}/reactivate`,
    );
    return data.data;
  },

  resetLogin: async (id: string) => {
    const { data } = await apiClient.patch<ApiResponse<ResetAdminLoginResponse>>(
      `/admin/admins/${id}/reset-login`,
    );
    return data.data;
  },
};
